export default "__VITE_ASSET__CO7pSevf__"